/*
  cdx: Lieferung & Zusatzservices im Warenkorb

  Gegenstuecke in Liquid:
    snippets/cdx-service-lieferart.liquid  – Lieferart + Aufraeumliste, einmal je Warenkorb
    snippets/cdx-service-options.liquid    – Auslöser + Optionen, einmal je Position

  Zwei Eigenheiten des Themes bestimmen den Aufbau:

  1. Warehouse rendert den Warenkorb nach jeder Aenderung neu, indem es `/cart?section_id=…`
     holt und den Container per innerHTML ersetzt. Eingebettete <script>-Bloecke laufen dabei
     nicht mehr, und jede Referenz auf ein Element wird ungueltig. Deshalb liegt die Logik in
     dieser Datei, und deshalb ist *alles* delegiert an document gebunden: es gibt keinen
     Zeitpunkt, zu dem ein Klick ins Leere gehen kann, weil gerade neu gerendert wurde.

  2. Der Drawer ist `position:fixed` mit `overflow:hidden`. Ein Dialog darin waere
     eingesperrt und abgeschnitten. Das Modal liegt deshalb auf Body-Ebene und bekommt
     seinen Inhalt als Kopie des Panels aus der jeweiligen Position.

  Die Regel-Logik selbst steckt komplett in Liquid bzw. im Metaobjekt `service_regel`.
  Dieses Script kennt nur: was ist angehakt, was liegt schon im Warenkorb, was muss weg.
*/

(function () {
  'use strict';

  var basisUrl = (window.routes && window.routes.cartUrl) || '/cart';
  var addUrl = ((window.routes && window.routes.cartAddUrl) || basisUrl + '/add') + '.js';
  var updateUrl = basisUrl + '/update.js';

  var holUrl = basisUrl + '.js';
  // Dieselbe Sektion, die auch das Theme fuer den Drawer nachlaedt. Wir holen sie, um die
  // serverseitig gerechnete Aufraeumliste zu lesen, ohne auf ein Ereignis zu warten.
  var sektionUrl = basisUrl + '?section_id=mini-cart';

  var laeuft = false;
  var nachtrag = false;
  var aufraeumVersuche = 0;

  var modal = null;
  var modalTitel = null;
  var modalSub = null;
  var modalBody = null;
  var modalStand = null;
  var vorherFokus = null;

  function alle(wurzel, selektor) {
    return Array.prototype.slice.call((wurzel || document).querySelectorAll(selektor));
  }

  function cartEl() {
    return document.querySelector('[data-cdx-cart]');
  }

  /* ------------------------------------------------------------------ Netz */

  function post(url, koerper) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(koerper)
    }).then(function (antwort) {
      if (antwort.ok) return antwort.json();
      return antwort
        .json()
        .catch(function () {
          return {};
        })
        .then(function (daten) {
          throw new Error(daten.description || daten.message || antwort.statusText);
        });
    });
  }

  /*
    Waehrend eine Aenderung laeuft, darf niemand zur Kasse. Der Warenkorb wird in dem
    Moment gerade umgebaut – ein Klick dazwischen fuehrte in einen Checkout mit halbem
    Stand: Service schon gebucht, Aufraeumen noch nicht durch.

    Im Modal selbst wird dagegen nichts gesperrt; dort zeigt nur ein Punkt in der
    Fusszeile, dass im Hintergrund gearbeitet wird. Wer hakt, soll weiterhaken koennen.
  */
  function arbeit(an) {
    if (modal) modal.classList.toggle('is-arbeitet', an);
    checkoutSperren(an);
  }

  function checkoutSperren(an) {
    alle(document, 'button[name="checkout"]').forEach(function (knopf) {
      knopf.disabled = an;
      knopf.classList.toggle('is-gesperrt', an);
    });

    // Express-Buttons kennen unseren Zustand nicht und wuerden direkt bezahlen.
    alle(document, '.additional-checkout-buttons').forEach(function (el) {
      el.classList.toggle('cdx-svc-express-aus', an);
    });
  }

  /*
    Ob es ueberhaupt etwas zu konfigurieren gibt, weiss erst das Positions-Snippet – es
    wertet die Regeln aus. Der Auslöser an der Lieferart wird deshalb versteckt gerendert
    und hier gezeigt, sobald ein Panel mit Optionen im Dokument steht.
  */
  function ausloeserZeigen() {
    var hatOptionen = !!document.querySelector('[data-cdx-services] [data-cdx-panel] [data-cdx-regel]');
    alle(document, '[data-cdx-open]').forEach(function (knopf) {
      knopf.hidden = !hatOptionen;
    });
  }

  // Die Meldung von Shopify wird woertlich gezeigt – "nicht verfuegbar" oder
  // "nicht in diesem Kanal" muss man sehen koennen, nicht raten muessen.
  function fehler(text) {
    alle(document, '[data-cdx-fehler]').forEach(function (el) {
      el.textContent = text || '';
      el.hidden = !text;
    });
  }

  /*
    Nach jeder Aenderung wird der Warenkorb einmal frisch gelesen und die Kopie im Modal
    daran ausgerichtet: welche Regel liegt mit welchem Line-Item-Key drin.

    Das ist der Grund, warum das Modal ohne Rerender auskommt. Frueher hing sein Zustand
    am `cart:rerendered` des Themes – kam das nicht (der Austausch dort passiert in einem
    verschachtelten `.then`, das nicht zurueckgegeben wird), blieb alles haengen.
  */
  function keysUebernehmen(warenkorb) {
    if (!modalBody || !warenkorb || !warenkorb.items) return;

    /*
      Die Line-Item-Keys werden immer nachgezogen – sie sind die Wahrheit des Servers.
      Die Haken dagegen nur, wenn kein Nachtrag ansteht.

      Sonst passiert Folgendes: waehrend eine Anfrage laeuft, wird ein zweiter Haken
      gesetzt und gemerkt. Die Antwort kennt ihn noch nicht, das Ausrichten am Warenkorb
      nimmt ihn wieder weg – und der nachgezogene Durchlauf findet keinen Unterschied
      mehr. Der zweite Klick war damit verloren.
    */
    alle(modalBody, '[data-cdx-regel]').forEach(function (feld) {
      var regel = feld.getAttribute('data-cdx-regel');
      var parent = feld.getAttribute('data-cdx-parent') || '';
      var treffer = null;

      warenkorb.items.forEach(function (posten) {
        var eig = posten.properties || {};
        if (eig._regel === regel && (eig._parent || '') === parent) treffer = posten;
      });

      feld.setAttribute('data-cdx-key', treffer ? treffer.key : '');
      if (!nachtrag) feld.checked = !!treffer;
    });

    // Radiogruppen: ist nichts davon gebucht, gehoert der Haken auf "nicht gewuenscht"
    if (!nachtrag) {
      alle(modalBody, '[data-cdx-leer]').forEach(function (feld) {
        var gruppe = feld.getAttribute('data-cdx-leer');
        var belegt = alle(modalBody, '[data-cdx-gruppe="' + cssEscape(gruppe) + '"]').some(function (f) {
          return f.checked;
        });
        feld.checked = !belegt;
      });
    }

    standAktualisieren();
  }

  function sende(auftrag) {
    var kette = Promise.resolve();

    if (auftrag.updates || auftrag.attributes) {
      var nutzlast = { updates: auftrag.updates || {} };
      if (auftrag.attributes) nutzlast.attributes = auftrag.attributes;
      kette = kette.then(function () {
        return post(updateUrl, nutzlast);
      });
    }

    if (auftrag.items && auftrag.items.length) {
      kette = kette.then(function () {
        return post(addUrl, { items: auftrag.items });
      });
    }

    return kette;
  }

  /*
    Was das frische Markup ansagt, in einen Auftrag uebersetzen: welche Service-Zeilen
    weg muessen (`data-cleanup`), welche auf eine andere Menge gehoeren (`data-rescale`)
    und welche Attribute zurueckzusetzen sind.

    Beide Wege gehen hier durch – der nach einer eigenen Aenderung (verwaisteFinden, holt
    das Markup selbst) und der nach einem fremden Rerender (aufraeumen, findet es schon
    im Dokument). Sonst stuenden zwei Auswertungen nebeneinander, die auseinanderlaufen
    koennen.
  */
  function auftragLesen(el) {
    if (!el) return null;

    var keys = (el.getAttribute('data-cleanup') || '').split(',').filter(Boolean);
    // Mengen als "key=menge" – der Line-Item-Key traegt selbst einen Doppelpunkt.
    var mengen = (el.getAttribute('data-rescale') || '').split(',').filter(Boolean);
    var attribut = el.getAttribute('data-cleanup-attr') || '';
    // Faellt der Warenkorb unter die Paketgrenze, gibt es keinen Wunschort mehr –
    // dann muss auch die gemerkte Lieferart zurueck, sonst blieben Services offen.
    var artFix = el.getAttribute('data-attr-fix') || '';

    if (!keys.length && !mengen.length && !attribut && !artFix) {
      aufraeumVersuche = 0;
      return null;
    }
    if (aufraeumVersuche >= 3) return null;
    aufraeumVersuche += 1;

    var auftrag = {};

    if (mengen.length || keys.length) auftrag.updates = {};

    // Erst die Mengen, dann die Entfernungen: was ohnehin weg muss, wird nicht
    // vorher noch angeglichen.
    mengen.forEach(function (eintrag) {
      var trenn = eintrag.lastIndexOf('=');
      if (trenn < 1) return;
      var key = eintrag.slice(0, trenn);
      var menge = Number(eintrag.slice(trenn + 1));
      if (key && menge > 0) auftrag.updates[key] = menge;
    });

    keys.forEach(function (key) {
      auftrag.updates[key] = 0;
    });

    if (attribut) {
      auftrag.attributes = auftrag.attributes || {};
      auftrag.attributes[attribut] = '';
    }
    if (artFix) {
      auftrag.attributes = auftrag.attributes || {};
      auftrag.attributes[artFix] = '';
    }

    return auftrag;
  }

  /*
    Welche gebuchten Services nach den aktuellen Regeln nicht mehr zulaessig sind, rechnet
    Liquid aus – die Regeln stehen im Metaobjekt, nicht hier. Also wird die Sektion frisch
    geholt und die fertige Liste daraus gelesen.

    Frueher haing das am `cart:rerendered` des Themes. Kam das nicht oder zu spaet, blieben
    die Services nach einem Wechsel auf Bordsteinkante bis zum naechsten Seitenaufruf liegen.
    Jetzt laeuft es in derselben Kette wie die Aenderung selbst.
  */
  function verwaisteFinden() {
    return fetch(sektionUrl, { credentials: 'same-origin', headers: { 'Cache-Control': 'no-cache' } })
      .then(function (antwort) {
        return antwort.text();
      })
      .then(function (html) {
        var huelle = document.createElement('div');
        huelle.innerHTML = html;

        return auftragLesen(huelle.querySelector('[data-cdx-cart]'));
      })
      .catch(function () {
        return null;
      });
  }

  // Aenderung ausfuehren und direkt danach abraeumen, was dadurch ungueltig wurde –
  // solange, bis nichts mehr uebrig bleibt.
  function ausfuehren(auftrag) {
    var etwasGetan = !!(auftrag.updates || auftrag.attributes || (auftrag.items && auftrag.items.length));

    return sende(auftrag)
      .then(verwaisteFinden)
      .then(function (folge) {
        if (!folge) return etwasGetan;
        return ausfuehren(folge).then(function () {
          return true;
        });
      });
  }

  /*
    Erst wenn diese eigene Kette durch ist, gilt der Auftrag als erledigt – unabhaengig
    davon, was das Theme tut.

    `cart:refresh` geht am Ende trotzdem raus: darueber aktualisiert Warehouse Drawer,
    Warenkorbseite und Header-Zaehler. Nur haengt daran nichts mehr von uns.
  */
  function anwenden(auftrag) {
    if (laeuft) {
      // Waehrend eine Anfrage laeuft weiterklicken duerfen: gemerkt und danach nachgezogen.
      nachtrag = true;
      return Promise.resolve();
    }

    laeuft = true;
    arbeit(true);
    fehler('');

    var geaendert = false;

    return ausfuehren(auftrag)
      .then(function (etwasGetan) {
        geaendert = etwasGetan;
        return fetch(holUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(
          function (antwort) {
            return antwort.json();
          }
        );
      })
      .then(function (warenkorb) {
        keysUebernehmen(warenkorb);

        // Nur melden, wenn sich wirklich etwas geaendert hat. Sonst wuerde ein leerer
        // Aufraeum-Durchlauf einen Rerender ausloesen, der den naechsten anstoesst.
        if (geaendert) {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } })
          );
        }
      })
      .catch(function (grund) {
        if (window.console && window.console.warn) {
          window.console.warn('[cdx-services]', grund);
        }
        fehler(String(grund && grund.message ? grund.message : grund));
      })
      .then(function () {
        laeuft = false;
        arbeit(false);

        if (nachtrag) {
          nachtrag = false;
          var panel = modalBody && modalBody.querySelector('[data-cdx-panel]');
          if (panel) auswahlGeaendert(panel);
        }
      });
  }

  /* ------------------------------------------------------------------ Modal */

  function baueModal() {
    if (modal) return;

    modal = document.createElement('div');
    modal.className = 'cdx-svcm';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="cdx-svcm__scrim" data-cdx-close></div>' +
      '<div class="cdx-svcm__box" role="dialog" aria-modal="true" aria-labelledby="cdx-svcm-titel">' +
      '<div class="cdx-svcm__head">' +
      '<div class="cdx-svcm__head-txt">' +
      '<h3 class="cdx-svcm__titel" id="cdx-svcm-titel"></h3>' +
      '<p class="cdx-svcm__sub"></p>' +
      '</div>' +
      '<button type="button" class="cdx-svcm__close" data-cdx-close aria-label="' +
      btT('cdx_cart_services.close', 'Schliessen') +
      '">' +
      '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M2 2l12 12M14 2L2 14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
      '</button>' +
      '</div>' +
      '<div class="cdx-svcm__body"></div>' +
      '<div class="cdx-svcm__foot">' +
      '<p class="cdx-svcm__fehler" data-cdx-fehler hidden></p>' +
      '<span class="cdx-svcm__stand"></span>' +
      '<button type="button" class="cdx-svcm__done" data-cdx-close></button>' +
      '</div>' +
      '</div>';

    document.body.appendChild(modal);

    modalTitel = modal.querySelector('.cdx-svcm__titel');
    modalSub = modal.querySelector('.cdx-svcm__sub');
    modalBody = modal.querySelector('.cdx-svcm__body');
    modalStand = modal.querySelector('.cdx-svcm__stand');

    /*
      Ereignisse aus dem Modal duerfen document.documentElement nicht erreichen.
      Warehouse haengt dort seinen Ausserhalb-Klick auf ("_onWindowClick" in theme.js,
      Bubble-Phase ueber die Delegate-Bibliothek) und schliesst den Drawer, sobald das
      Ziel nicht im Header liegt. Das Modal liegt auf Body-Ebene – jeder Klick darin
      galt damit als Klick nach draussen.

      Deshalb haengen Klick und Change hier direkt am Modal statt an document: die
      Bubble-Phase endet an dieser Stelle. Das Modal wird einmal erzeugt und nie
      ersetzt, es braucht also keine Delegation, um Rerender zu ueberstehen.
    */
    modal.addEventListener('click', function (ereignis) {
      ereignis.stopPropagation();
      var ziel = ereignis.target;
      if (ziel && ziel.closest && ziel.closest('[data-cdx-close]')) {
        ereignis.preventDefault();
        schliesse();
      }
    });

    modal.addEventListener('mousedown', function (ereignis) {
      ereignis.stopPropagation();
    });

    modal.addEventListener('change', function (ereignis) {
      ereignis.stopPropagation();
      var ziel = ereignis.target;
      if (!ziel || !ziel.matches || !ziel.matches('[data-cdx-regel], [data-cdx-leer]')) return;

      var panel = ziel.closest('[data-cdx-panel]');
      if (!panel) return;
      standAktualisieren();
      auswahlGeaendert(panel);
    });
  }

  function texte() {
    var el = cartEl();
    return {
      titel: (el && el.getAttribute('data-text-titel')) || btT('cdx_cart_services.title', 'Zusatzservices'),
      fertig: (el && el.getAttribute('data-text-fertig')) || btT('cdx_cart_services.done', 'Fertig'),
      gewaehlt: (el && el.getAttribute('data-text-gewaehlt')) || btT('cdx_cart_services.selected', 'gewählt'),
      keine: (el && el.getAttribute('data-text-nichts')) || btT('cdx_cart_services.nothing_selected', 'Nichts gewählt'),
      produkte: (el && el.getAttribute('data-text-produkte')) || btT('cdx_cart_services.products', 'Produkte')
    };
  }

  /*
    Das Modal zeigt den ganzen Warenkorb: je Position, fuer die es etwas zu waehlen gibt,
    ein Abschnitt mit dem Produktnamen darueber. Zusatzservices haengen an der Lieferart,
    nicht an der einzelnen Zeile – also wird auch an einer Stelle konfiguriert.

    Der Inhalt ist eine Kopie, kein verschobenes Original: nach jedem Rerender wird er
    aus dem frischen Markup neu erzeugt. Nichts haengt daran, dass ein Element ueberlebt.
  */
  function fuelleModal() {
    var panels = alle(document, '[data-cdx-services] [data-cdx-panel]').filter(function (panel) {
      return !!panel.querySelector('[data-cdx-regel]');
    });
    if (!panels.length) return false;

    var t = texte();
    // Beim Neuaufbau nach einem Rerender soll die Liste nicht nach oben springen
    var scrollStand = modalBody.scrollTop;

    modalTitel.textContent = t.titel;
    modalSub.textContent = panels.length > 1 ? panels.length + ' ' + t.produkte : '';
    modalBody.innerHTML = '';

    panels.forEach(function (panel) {
      var block = document.createElement('div');
      block.className = 'cdx-svcm__produkt';

      var titel = document.createElement('p');
      titel.className = 'cdx-svcm__produkt-titel';
      titel.textContent = panel.getAttribute('data-titel') || '';
      block.appendChild(titel);

      var klon = panel.cloneNode(true);
      klon.hidden = false;

      // Eindeutige Feldnamen, damit die Radiogruppen der Kopie nicht mit denen
      // des versteckten Originals im selben Dokument verschmelzen.
      alle(klon, 'input[name]').forEach(function (feld) {
        feld.name = feld.name + '--modal';
      });

      block.appendChild(klon);
      modalBody.appendChild(block);
    });

    modalBody.scrollTop = scrollStand;
    modal.querySelector('.cdx-svcm__done').textContent = t.fertig;

    standAktualisieren();
    return true;
  }

  function standAktualisieren() {
    if (!modalStand) return;
    var t = texte();
    var anzahl = alle(modalBody, '[data-cdx-regel]').filter(function (feld) {
      return feld.checked;
    }).length;
    modalStand.textContent = anzahl > 0 ? anzahl + ' ' + t.gewaehlt : t.keine;
  }

  function oeffne() {
    baueModal();
    if (!fuelleModal()) return;

    vorherFokus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('cdx-svcm-offen');

    var ziel = modalBody.querySelector('input:not([disabled])') || modal.querySelector('.cdx-svcm__done');
    if (ziel) ziel.focus();
  }

  function schliesse() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.classList.remove('cdx-svcm-offen');

    var zurueck = vorherFokus;
    if (!zurueck || !document.contains(zurueck)) {
      zurueck = document.querySelector('[data-cdx-open]');
    }
    if (zurueck && zurueck.focus) zurueck.focus();
    vorherFokus = null;
  }

  // Nach einem Rerender zeigt das Modal noch die alte Kopie – hier kommt die neue rein.
  function synchronisiere() {
    if (!modal || modal.hidden) return;

    // Ist nach der Aenderung nichts mehr zu konfigurieren – Tresor entfernt, Lieferart
    // gewechselt –, schliesst das Modal, statt leer stehen zu bleiben.
    if (!fuelleModal()) schliesse();
  }

  function cssEscape(wert) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(wert);
    return String(wert).replace(/["\\]/g, '\\$&');
  }

  function fokusFalle(ereignis) {
    var ziele = alle(modal, 'button, input, a[href], select, textarea').filter(function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
    if (!ziele.length) return;

    var erstes = ziele[0];
    var letztes = ziele[ziele.length - 1];

    if (ereignis.shiftKey && document.activeElement === erstes) {
      ereignis.preventDefault();
      letztes.focus();
    } else if (!ereignis.shiftKey && document.activeElement === letztes) {
      ereignis.preventDefault();
      erstes.focus();
    }
  }

  /* ------------------------------------------------------------------ Auswahl */

  function auswahlGeaendert(panel) {
    var eintraege = alle(panel, '[data-cdx-regel]');

    var hinzu = [];
    var weg = [];
    var attributStand = {};

    eintraege.forEach(function (feld) {
      var attribut = feld.getAttribute('data-cdx-attribut');
      if (attribut && !(attribut in attributStand)) attributStand[attribut] = false;

      var key = feld.getAttribute('data-cdx-key') || '';

      if (feld.checked) {
        if (attribut) attributStand[attribut] = true;

        if (!key) {
          // `_parent` klammert den Service an genau diesen Tresor, `_label` traegt den
          // Regel-Namen fuer die Anzeige. Beide versteckt, `Bezug` bleibt sichtbar,
          // damit im Checkout und auf dem Lieferschein steht, wozu der Service gehoert.
          //
          // `_parent_variant` ist die Klammer fuer den Checkout (B4): dort gibt es den
          // Line-Item-Key aus `_parent` nicht, die Varianten-ID dagegen schon.
          var eigenschaften = { _regel: feld.getAttribute('data-cdx-regel') };
          var parent = feld.getAttribute('data-cdx-parent');
          var parentVariant = feld.getAttribute('data-cdx-parent-variant');
          var label = feld.getAttribute('data-cdx-label');
          var bezug = feld.getAttribute('data-cdx-bezug');

          if (parent) eigenschaften._parent = parent;
          if (parentVariant) eigenschaften._parent_variant = parentVariant;
          if (label) eigenschaften._label = label;
          if (bezug) eigenschaften.Bezug = bezug;

          // Die Menge des Tresors schlaegt auf den Service durch (Entscheidung BT,
          // 24.08.2026): zwei Tresore in einer Zeile bekommen denselben Service, zweimal.
          // Die Menge steht am Feld, gerendert aus `line_item.quantity`.
          hinzu.push({
            id: Number(feld.getAttribute('data-cdx-variant')),
            quantity: Number(feld.getAttribute('data-cdx-menge')) || 1,
            properties: eigenschaften
          });
        }
      } else if (key) {
        weg.push(key);
      }
    });

    if (!hinzu.length && !weg.length) return;

    var auftrag = {};
    if (hinzu.length) auftrag.items = hinzu;
    if (weg.length) {
      auftrag.updates = {};
      weg.forEach(function (key) {
        auftrag.updates[key] = 0;
      });
    }

    // Cart-Attribute haengen am Warenkorb, nicht an der Position – der Stand kommt
    // deshalb vom Lieferart-Block.
    var aktuell = {};
    var el = cartEl();
    try {
      aktuell = JSON.parse((el && el.getAttribute('data-attribute')) || '{}');
    } catch (e) {
      aktuell = {};
    }

    Object.keys(attributStand).forEach(function (name) {
      var soll = attributStand[name] ? 'Ja' : '';
      if ((aktuell[name] || '') !== soll) {
        auftrag.attributes = auftrag.attributes || {};
        auftrag.attributes[name] = soll;
      }
    });

    anwenden(auftrag);
  }

  /* ------------------------------------------------------------------ Versandpreise

     Die Wunschort-Staffel liegt in ShipX und richtet sich allein nach dem Warenkorbgewicht.
     Statt sie im Theme nachzubauen – zweite Preisquelle, die auseinanderlaeuft, sobald
     jemand nur ShipX pflegt – wird derselbe Endpunkt gefragt, den auch der Checkout
     benutzt. Was hier steht, ist der Betrag, der spaeter berechnet wird.

     Bis die Antwort da ist, bleibt der in den Einstellungen hinterlegte Hinweis stehen. */

  var ratenStand = null;

  /*
    Geldbetraege folgen dem Geldformat des Shops, nicht der Sprache des Dokuments.
    Intl.NumberFormat schrieb sonst "1.294,00 CHF" neben Liquids "CHF 1'055.00" –
    zwei Schreibweisen im selben Kasten. Hier wird dieselbe Vorlage ausgewertet, die
    auch der `money`-Filter benutzt (window.theme.moneyWithCurrencyFormat).
  */
  function zahlFormat(wert, stellen, tausender, dezimal) {
    var text = Math.abs(wert).toFixed(stellen);
    var teile = text.split('.');
    var ganz = teile[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + tausender);
    return (wert < 0 ? '-' : '') + ganz + (stellen ? dezimal + teile[1] : '');
  }

  var TRENNER = {
    amount: [2, ',', '.'],
    amount_no_decimals: [0, ',', '.'],
    amount_with_comma_separator: [2, '.', ','],
    amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_apostrophe_separator: [2, "'", '.'],
    amount_no_decimals_with_apostrophe_separator: [0, "'", '.'],
    amount_with_space_separator: [2, ' ', ','],
    amount_no_decimals_with_space_separator: [0, ' ', ',']
  };

  function shopFormat() {
    return (window.theme && window.theme.moneyWithCurrencyFormat) || '{{amount}}';
  }

  function geldVoll(betrag) {
    var wert = parseFloat(betrag);
    if (isNaN(wert)) return '';

    return shopFormat().replace(/\{\{\s*(\w+)\s*\}\}/, function (ganz, name) {
      var art = TRENNER[name] || TRENNER.amount;
      return zahlFormat(wert, art[0], art[1], art[2]);
    });
  }


  /*
    Versandbetraege werden auf ganze Betraege gerundet gezeigt. Der Checkout rechnet mit
    dem Originalwert – bei krummen Raten weicht die Anzeige also um bis zu einen halben
    Franken ab. Sauber loest man das in ShipX mit glatten Betraegen.
  */
  function versandBetrag(rate) {
    return rate ? Math.round(parseFloat(rate.price)) : null;
  }

  function rateFuer(wert, raten) {
    var el = cartEl();
    if (!el || !raten) return null;

    var praefix = el.getAttribute('data-rate-' + wert) || '';
    if (!praefix) return null;

    // Jede Gewichtsstufe ist ein eigenes Szenario; zutreffend ist immer genau eine.
    // Kaemen doch mehrere zurueck, ist die guenstigste die, die der Kunde waehlen wuerde.
    var passend = raten.filter(function (rate) {
      return (rate.name || '').indexOf(praefix) === 0;
    });
    if (!passend.length) return null;

    passend.sort(function (a, b) {
      return parseFloat(a.price) - parseFloat(b.price);
    });
    return passend[0];
  }

  function aktiveLieferart() {
    var knopf = document.querySelector('[data-cdx-lieferart].is-aktiv');
    if (knopf) return knopf.getAttribute('data-cdx-lieferart');

    var el = cartEl();
    return (el && el.getAttribute('data-lieferart')) || 'bordsteinkante';
  }

  /*
    Woran sich die Raten aendern koennen. Das Gewicht allein reicht nicht: Services sind
    gewichtslos, blenden aber ueber die Delivery Customization die Bordsteinkante aus.
    Nur nach Gewicht gemerkt, galt nach dem Entfernen der Services weiter der alte Stand –
    die Bordsteinkante blieb verschwunden und die Auswahl sprang auf Wunschort zurueck.
  */
  function ratenSchluessel(el) {
    return [
      el.getAttribute('data-gewicht') || '',
      el.getAttribute('data-zwischensumme') || '',
      el.getAttribute('data-hat-services') || ''
    ].join('|');
  }

  /*
    Zuletzt gesehener Betrag je Lieferart. Blendet die Delivery Customization eine Rate
    aus, weil Services gebucht sind, steht sonst der Rueckfalltext neben einer Art, fuer
    die wir den Preis eben noch kannten – und der Kunde sieht "gratis" statt "CHF 0.00".
  */
  var gemerkt = {};

  function merken(wert, betrag) {
    if (betrag !== null) {
      gemerkt[wert] = betrag;
      return betrag;
    }
    return gemerkt[wert] === undefined ? null : gemerkt[wert];
  }

  /*
    Preise in die Umschalter schreiben und Arten ausblenden, fuer die ShipX gar keine
    Rate liefert – eine Wahl, die keine ist, gehoert nicht auf den Bildschirm. Bleibt nur
    eine uebrig, verliert die Gruppe ihre Umschalter-Optik.

    Ausgeblendet wird aber nur, solange keine Services gebucht sind. Liegen welche im
    Warenkorb, blendet die Delivery Customization die Bordsteinkante aus der Ratenliste –
    und ohne diese Ausnahme gaebe es keinen Weg zurueck: der Wechsel auf Bordsteinkante
    ist ja genau das, was die Services entfernt und die Rate wieder freigibt.
  */
  function ratenSetzen(raten, frisch) {
    var knoepfe = alle(document, '[data-cdx-lieferart]');
    if (!knoepfe.length) {
      summeAktualisieren();
      return;
    }

    var el = cartEl();
    var mitServices = !!el && el.getAttribute('data-hat-services') === '1';
    var hatRaten = raten && raten.length > 0;
    var sichtbar = [];

    knoepfe.forEach(function (knopf) {
      var wert = knopf.getAttribute('data-cdx-lieferart');
      var roh = versandBetrag(rateFuer(wert, raten));
      var preisEl = knopf.querySelector('[data-cdx-opt-preis]');

      if (hatRaten && roh === null && !mitServices) {
        knopf.hidden = true;
        return;
      }
      knopf.hidden = false;
      sichtbar.push(knopf);

      if (preisEl) {
        var betrag = merken(wert, roh);

        // Die Null bekommt das Wort statt der Zahl: in einer Auswahl liest sich das
        // schneller als ein Betrag, der ohnehin keiner ist. Der Aufpreis steht mit
        // Plus da, damit klar ist, dass er obendrauf kommt.
        if (betrag === null) {
          // Kein Preis bekannt: der Rueckfalltext aus dem Markup bleibt, aber scharf.
          preisEl.classList.remove('is-wechsel');
        } else if (betrag === 0) {
          weichSetzen(preisEl, (el && el.getAttribute('data-text-gratis')) || geldVoll(0));
        } else {
          weichSetzen(preisEl, '+ ' + geldVoll(betrag));
        }
        preisEl.classList.toggle('is-gratis', betrag === 0);
      }
    });

    alle(document, '[data-cdx-wahl]').forEach(function (gruppe) {
      gruppe.classList.toggle('cdx-lief__wahl--einzeln', sichtbar.length < 2);
    });

    /*
      Steht die gewaehlte Art nicht mehr zur Verfuegung, auf die verbliebene wechseln.
      Drei Bedingungen muessen dafuer erfuellt sein:

      – keine Services gebucht: dort fehlt die Rate mit Absicht, und ein automatischer
        Wechsel wuerde dem Kunden seine Buchung wegnehmen, ohne dass er etwas anklickt.
      – die Raten sind frisch geholt: aus dem Zwischenspeicher heraus umzuschalten hiesse,
        eine Entscheidung auf veraltete Daten zu stuetzen.
      – es gibt ueberhaupt Raten.
    */
    if (frisch && hatRaten && !mitServices && sichtbar.length && !rateFuer(aktiveLieferart(), raten)) {
      lieferartWaehlen(sichtbar[0]);
      return;
    }

    summeAktualisieren();
  }

  /*
    Rechnung unter der Auswahl: Versand zur gewaehlten Art und Gesamtsumme. Gerechnet
    wird mit dem gerundeten Versandbetrag, damit die angezeigten Zeilen zusammenpassen.
  */
  function summeAktualisieren() {
    var el = cartEl();
    if (!el || !document.querySelector('[data-cdx-summe]')) return;

    var wert = aktiveLieferart();
    var betrag = merken(wert, ratenStand ? versandBetrag(rateFuer(wert, ratenStand.raten)) : null);
    var zwischensumme = parseFloat(el.getAttribute('data-zwischensumme') || '0') / 100;

    var gratis = el.getAttribute('data-text-gratis') || '';

    alle(document, '[data-cdx-versand]').forEach(function (zelle) {
      if (betrag === null) {
        // Ohne Raten bleibt die Zelle leer statt falsch – aber nicht unscharf.
        zelle.classList.remove('is-wechsel');
        return;
      }
      // Wie in der Auswahl: null bekommt das Wort, alles andere den Betrag.
      weichSetzen(zelle, betrag === 0 && gratis ? gratis : geldVoll(betrag));
      zelle.classList.toggle('cdx-lief__gratis', betrag === 0);
    });

    alle(document, '[data-cdx-gesamt]').forEach(function (zelle) {
      weichSetzen(zelle, geldVoll(zwischensumme + (betrag || 0)));
    });
  }

  /*
    Betraege wechseln weich statt zu springen. Beim Umschalten der Lieferart aendern sich
    Versand und Gesamtsumme gleichzeitig, und nach dem Rerender kommen die Zellen frisch
    aus Liquid – ohne den Versand, den nur das Script kennt. Ohne Uebergang blitzte dabei
    kurz eine Zwischenzahl auf.

    Die Zellen tragen die Unschaerfe schon aus dem Markup; hier wird sie aufgeloest,
    sobald der richtige Wert steht.
  */
  function weichSetzen(zelle, text) {
    if (zelle.textContent === text) {
      zelle.classList.remove('is-wechsel');
      return;
    }

    clearTimeout(zelle.cdxWechsel);
    zelle.classList.add('is-wechsel');

    zelle.cdxWechsel = setTimeout(function () {
      zelle.textContent = text;
      zelle.classList.remove('is-wechsel');
    }, 130);
  }

  // Umschalten: erst die Ansicht, dann der Warenkorb. Der Kunde soll nicht auf den
  // Serverlauf warten, um zu sehen, was seine Wahl kostet.
  function lieferartWaehlen(knopf) {
    var wert = knopf.getAttribute('data-cdx-lieferart');
    var el = cartEl();

    alle(document, '[data-cdx-lieferart]').forEach(function (anderer) {
      var an = anderer.getAttribute('data-cdx-lieferart') === wert;
      anderer.classList.toggle('is-aktiv', an);
      anderer.setAttribute('aria-checked', an ? 'true' : 'false');
    });

    alle(document, '[data-cdx-versand-name]').forEach(function (zelle) {
      zelle.textContent = knopf.getAttribute('data-label') || zelle.textContent;
    });

    if (el) {
      var text = el.getAttribute('data-text-' + wert) || '';
      alle(document, '[data-cdx-lief-text]').forEach(function (zelle) {
        zelle.textContent = text;
      });
    }

    summeAktualisieren();

    // Services, die zur neuen Art nicht mehr passen, raeumt der naechste Durchlauf
    // ueber data-cleanup ab – serverseitig, nicht hier.
    anwenden({ attributes: { Lieferart: wert } });
  }

  function ratenHolen() {
    var el = cartEl();
    if (!el) return;

    var land = el.getAttribute('data-rate-land') || '';
    var plz = el.getAttribute('data-rate-plz') || '';
    if (!land || !plz) return;

    var schluessel = ratenSchluessel(el);
    if (ratenStand && ratenStand.schluessel === schluessel) {
      ratenSetzen(ratenStand.raten, false);
      return;
    }

    // Leere Parameter weglassen: fuer die Schweiz gibt es keine Provinz, und ein leerer
    // Wert kann die Adresspruefung des Endpunkts unnoetig scheitern lassen.
    var teile = ['shipping_address[country]=' + encodeURIComponent(land)];
    if (plz) teile.push('shipping_address[zip]=' + encodeURIComponent(plz));
    var provinz = el.getAttribute('data-rate-provinz') || '';
    if (provinz) teile.push('shipping_address[province]=' + encodeURIComponent(provinz));

    var url = basisUrl + '/shipping_rates.json?' + teile.join('&');

    /*
      Ein Versuch reicht nicht immer: berechnet eine App die Raten ueber einen Carrier
      Service, antwortet Shopify beim ersten Aufruf gelegentlich mit einer leeren Liste,
      waehrend die Anfrage beim Anbieter noch laeuft. Deshalb ein zweiter Anlauf nach
      kurzer Pause, bevor wir aufgeben.
    */
    function versuch(nummer) {
      return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (antwort) {
          return antwort.json();
        })
        .then(function (daten) {
          var raten = (daten && daten.shipping_rates) || [];

          if (!raten.length && nummer < 2) {
            return new Promise(function (weiter) {
              setTimeout(weiter, 1500);
            }).then(function () {
              return versuch(nummer + 1);
            });
          }

          ratenStand = { schluessel: schluessel, raten: raten };
          ratenSetzen(raten, true);
        });
    }

    versuch(1).catch(function (grund) {
      // Ohne Antwort bleiben die hinterlegten Hinweise stehen – lieber kein Preis
      // als ein falscher.
      if (window.console && window.console.warn) {
        window.console.warn('[cdx-services] Versandraten', grund);
      }
    });
  }

  /* ------------------------------------------------------------------ Aufraeumen */

  /*
    Gleiche Aufgabe wie verwaisteFinden, nur ohne Anfrage: nach einem Rerender steht die
    Liste bereits im frischen Markup. Gebraucht wird das fuer Aenderungen, die nicht von
    uns kommen – etwa wenn jemand den Tresor ueber das Theme aus dem Warenkorb wirft und
    damit die daran haengenden Services verwaisen, oder seine Menge aendert und die
    Services nachziehen muessen.
  */
  function aufraeumen() {
    if (laeuft) return;

    var auftrag = auftragLesen(cartEl());
    if (!auftrag) return;

    anwenden(auftrag);
  }

  /* ------------------------------------------------------------------ Delegation */

  /*
    Auslöser und Lieferart liegen im Warenkorb-Markup, das bei jeder Aenderung ersetzt
    wird – deshalb delegiert an document und nicht an die Elemente selbst. Beide liegen
    im Header bzw. auf der Warenkorbseite, der Ausserhalb-Klick des Themes stoert hier
    also nicht. Was im Modal passiert, faengt das Modal selbst ab (siehe baueModal).
  */
  document.addEventListener('click', function (ereignis) {
    var ziel = ereignis.target;
    if (!ziel || !ziel.closest) return;

    var art = ziel.closest('[data-cdx-lieferart]');
    if (art) {
      ereignis.preventDefault();
      if (!art.classList.contains('is-aktiv')) lieferartWaehlen(art);
      return;
    }

    var oeffner = ziel.closest('[data-cdx-open]');
    if (!oeffner) return;

    ereignis.preventDefault();
    oeffne();
  });

  document.addEventListener('keydown', function (ereignis) {
    if (!modal || modal.hidden) return;
    if (ereignis.key === 'Escape') {
      ereignis.preventDefault();
      schliesse();
    } else if (ereignis.key === 'Tab') {
      fokusFalle(ereignis);
    }
  });

  /*
    Nacharbeit an frisch gerendertem Markup.

    Warehouse tauscht den Warenkorb nach jeder Aenderung per innerHTML aus. Alles, was
    nur im JavaScript existiert, ist danach weg: der Versandbetrag aus den Raten steht
    nicht im Liquid, die Gesamtsumme faellt auf die Zwischensumme zurueck. Es muss also
    nachgezogen werden.

    Frueher haing das am Ereignis `cart:rerendered` des Themes. Das wird aus einem
    verschachtelten `.then` gefeuert, das nicht zurueckgegeben wird – bleibt es aus,
    bleibt auch die Nacharbeit aus, und der eben noch richtige Betrag sprang zurueck.

    Der Austausch selbst ist dagegen nicht zu uebersehen: er fuegt Knoten ein. Genau
    darauf wird hier gehorcht, statt auf ein Signal zu vertrauen, das jemand anderes
    sendet. Reagiert wird nur auf eingefuegte Elemente, die unsere Bausteine enthalten –
    die Textaktualisierungen weiter unten loesen sonst sich selbst wieder aus.
  */
  var nacharbeitTimer = null;

  new MutationObserver(function (eintraege) {
    if (laeuft) return;

    var betroffen = eintraege.some(function (eintrag) {
      return Array.prototype.some.call(eintrag.addedNodes, function (knoten) {
        if (knoten.nodeType !== 1) return false;
        return (
          knoten.matches('[data-cdx-cart], [data-cdx-services]') ||
          !!knoten.querySelector('[data-cdx-cart], [data-cdx-services]')
        );
      });
    });
    if (!betroffen) return;

    clearTimeout(nacharbeitTimer);
    nacharbeitTimer = setTimeout(function () {
      if (laeuft) return;
      synchronisiere();
      ausloeserZeigen();
      aufraeumen();
      ratenHolen();
    }, 60);
  }).observe(document.body, { childList: true, subtree: true });

  /* ==========================================================================
     ZUBEHOER AUS DEM WARENKORB HINZUFUEGEN (19.08.2026)

     Das Markup dazu liefert snippets/cdx-cart-crosssell.liquid, im Drawer und
     auf der Warenkorbseite. Der Knopf haengt hier und nicht dort, weil
     Warehouse beide per innerHTML austauscht: ein Handler, der sich beim Laden
     an den Knopf bindet, waere nach dem ersten Nachrendern tot. Delegiert am
     Dokument ueberlebt er jeden Austausch — derselbe Grund, aus dem diese
     ganze Datei global geladen wird.

     Nach dem Hinzufuegen geht cart:refresh raus, darueber zeichnet Warehouse
     Drawer und Seite neu. Der Vorschlag verschwindet dabei von selbst aus der
     Liste: das Snippet blendet aus, was schon im Warenkorb liegt.
     ========================================================================== */
  function zubehoerHinzufuegen(knopf) {
    var id = knopf.getAttribute('data-variant');
    if (!id || knopf.disabled) return;

    knopf.disabled = true;
    knopf.setAttribute('aria-busy', 'true');

    post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
      .then(function () {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } })
        );
      })
      .catch(function (grund) {
        knopf.disabled = false;
        knopf.removeAttribute('aria-busy');
        if (window.console && window.console.warn) {
          window.console.warn('[cdx-crosssell]', grund);
        }
        fehler(String(grund && grund.message ? grund.message : grund));
      });
  }

  document.addEventListener('click', function (ereignis) {
    var knopf =
      ereignis.target && ereignis.target.closest ? ereignis.target.closest('[data-cdx-cs-add]') : null;
    if (!knopf) return;
    ereignis.preventDefault();
    zubehoerHinzufuegen(knopf);
  });

  function start() {
    ausloeserZeigen();
    aufraeumen();
    ratenHolen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
